import React from 'react';
import './PageLoading.css';

/**
 * Shared loading UI: page shell, compact (modals), inline/muted (table headers).
 */
export default function PageLoading({
  message = 'Loading…',
  variant = 'page',
  className = '',
}) {
  const containerClass = `app-page-loading app-page-loading--${variant} ${className}`.trim();

  if (variant === 'inline' || variant === 'muted') {
    return (
      <span className={containerClass} role="status" aria-live="polite">
        <span className="app-page-loading__dot-spinner" aria-hidden />
        {message}
      </span>
    );
  }

  return (
    <div className={containerClass} role="status" aria-live="polite">
      <div className="app-page-loading__spinner-container">
        <div className="app-page-loading__spinner" aria-hidden />
        <div className="app-page-loading__spinner-inner" aria-hidden />
      </div>
      {message ? <p className="app-page-loading__message">{message}</p> : null}
    </div>
  );
}
